import { EntryCollection } from 'contentful';

import { IExperienceFields } from '../../../@types/generated/contentful';
import { useContentfulFetchers } from '../../context/ContentfulContext';
import { useAsyncContentfulQuery } from './useAsyncContentfulQuery';

export function useExperienceQuery() {
  const { fetchExperience } = useContentfulFetchers();
  return useAsyncContentfulQuery<EntryCollection<IExperienceFields>>(() => fetchExperience(), [
    fetchExperience,
  ]);
}
